<template>
    <div class="p-t-xs-20 p-b-xs-20">
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-12">
                    <div class="m-b-xs-20">
                        <ak-button
                            size="small"
                            @click="backToGrid"
                        >
                            <i class="ak-icon ak-button__icon">arrow_left</i>
                            {{ $t('Ga terug') }}
                        </ak-button>
                    </div>
                </div>
            </div>
            <div v-if="user" class="row">
                <div class="col-lg-6">
                    <div class="ak-panel ak-panel--no-padding m-b-xs-20">
                        <div class="ak-panel__header ak-panel__header--info ak-panel__header--small">
                            <div class="ak-panel__title">
                                {{ $t('Persoonsgegevens') }} <b>{{ user.email }}</b>
                            </div>
                        </div>
                        <table v-if="!loading" class="ak-table ak-panel__table">
                            <thead>
                                <tr class="ak-table-row">
                                    <th class="ak-table-column">{{ $t('Veld') }}</th>
                                    <th class="ak-table-column">{{ $t('Waarde') }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="ak-table-row">
                                    <td class="ak-table-column">
                                        <i class="muted">{{ $t('E-mailadres') }}:</i>
                                    </td>
                                    <td class="ak-table-column">
                                        <a target="_blank">
                                            {{ user.email }}
                                        </a>
                                    </td>
                                </tr>
                                <tr class="ak-table-row">
                                    <td class="ak-table-column">
                                        <i class="muted">{{ $t('Voornaam') }}:</i>
                                    </td>
                                    <td class="ak-table-column">
                                        <a target="_blank">
                                            {{ user.firstName }}
                                        </a>
                                    </td>
                                </tr>
                                <tr class="ak-table-row">
                                    <td class="ak-table-column">
                                        <i class="muted">{{ $t('Achternaam') }}:</i>
                                    </td>
                                    <td class="ak-table-column">
                                        <a target="_blank">
                                            {{ user.surname }}
                                        </a>
                                    </td>
                                </tr>
                                <tr class="ak-table-row">
                                    <td class="ak-table-column">
                                        <i class="muted">{{ $t('Adres') }}:</i>
                                    </td>
                                    <td class="ak-table-column">
                                        <a target="_blank">
                                            {{ user.fullAddress }}
                                        </a>
                                    </td>
                                </tr>
                                <tr class="ak-table-row">
                                    <td class="ak-table-column">
                                        <i class="muted">{{ $t('Tweede adres') }}:</i>
                                    </td>
                                    <td class="ak-table-column">
                                        <a target="_blank">
                                            {{ user.fullAddressSecond }}
                                        </a>
                                    </td>
                                </tr>
                                <tr class="ak-table-row">
                                    <td class="ak-table-column">
                                        <i class="muted">{{ $t('Telefoonnummer') }}:</i>
                                    </td>
                                    <td class="ak-table-column">
                                        <a target="_blank">
                                            {{ user.phone }}
                                        </a>
                                    </td>
                                </tr>
                                <tr class="ak-table-row">
                                    <td class="ak-table-column">
                                        <i class="muted">{{ $t('GMS-nummer') }}:</i>
                                    </td>
                                    <td class="ak-table-column">
                                        <a target="_blank">
                                            {{ user.mobile }}
                                        </a>
                                    </td>
                                </tr>
                                <tr class="ak-table-row">
                                    <td class="ak-table-column">
                                        <i class="muted">{{ $t('KUL ID') }}:</i>
                                    </td>
                                    <td class="ak-table-column">
                                        <a target="_blank">
                                            {{ user.kulId }}
                                        </a>
                                    </td>
                                </tr>
                                <tr class="ak-table-row">
                                    <td class="ak-table-column">
                                        <i class="muted">{{ $t('KUL UID') }}:</i>
                                    </td>
                                    <td class="ak-table-column">
                                        <a target="_blank">
                                            {{ user.kulUid }}
                                        </a>
                                    </td>
                                </tr>
                                <tr class="ak-table-row">
                                    <td class="ak-table-column">
                                        <i class="muted">{{ $t('Mobile app token') }}:</i>
                                    </td>
                                    <td class="ak-table-column">
                                        <a target="_blank">
                                            {{ user.firebaseToken }}
                                        </a>
                                    </td>
                                </tr>
                                <tr class="ak-table-row">
                                    <td class="ak-table-column">
                                        <i class="muted">{{ $t('Opmerkingen') }}:</i>
                                    </td>
                                    <td class="ak-table-column">
                                        <a target="_blank">
                                            {{ user.remarks }}
                                        </a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="ak-panel ak-panel--no-padding m-b-xs-20">
                        <div class="ak-panel__header ak-panel__header--info ak-panel__header--small">
                            <div class="ak-panel__title">
                                {{ $t('Bestelbonnen') }} <b>{{ user.email }}</b>
                            </div>
                        </div>
                        <table v-if="!loading" class="ak-table ak-panel__table">
                            <thead>
                                <tr class="ak-table-row">
                                    <th class="ak-table-column">{{ $t('Nummer') }}</th>
                                    <th class="ak-table-column">{{ $t('Leverancier') }}</th>
                                    <th class="ak-table-column">{{ $t('Datum') }}</th>
                                </tr>
                            </thead>
                            <tbody v-if="orderRequests">
                                <tr v-for="orderRequest in orderRequests" class="ak-table-row">
                                    <td class="ak-table-column">
                                        <a :href="`:/download/order-request-pdf/${orderRequest.hashId}`">
                                            {{ orderRequest.code }}
                                        </a>
                                    </td>
                                    <td class="ak-table-column">
                                        {{ orderRequest.supplierName }}
                                    </td>
                                    <td class="ak-table-column">
                                        {{ orderRequest.dateForDisplay }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="ak-panel ak-panel--no-padding m-b-xs-20">
                        <div class="ak-panel__header ak-panel__header--info ak-panel__header--small">
                            <div class="ak-panel__title">
                                {{ $t('Bestellingen') }} <b>{{ user.email }}</b>
                            </div>
                        </div>
                        <table v-if="!loading" class="ak-table ak-panel__table">
                            <thead>
                                <tr class="ak-table-row">
                                    <th class="ak-table-column">{{ $t('Bestelnummer') }}</th>
                                    <th class="ak-table-column">{{ $t('Datum') }}</th>
                                    <th class="ak-table-column">{{ $t('Bedrag') }}</th>
                                </tr>
                            </thead>
                            <tbody v-if="orders">
                                <tr v-for="order in orders" class="ak-table-row">
                                    <template v-if="order.cart">
                                        <td class="ak-table-column">
                                            <router-link :to="{name: 'order-overview', params: {'orderCode': order.cart.code}}" target="_blank">
                                                {{ order.cart.code }}
                                            </router-link>
                                        </td>
                                        <td class="ak-table-column">
                                            {{ order.date | datetime }}
                                        </td>
                                        <td class="ak-table-column">
                                            {{ order.cart.totalPriceAfterTaxesForDisplay }}
                                        </td>
                                    </template>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="ak-panel ak-panel--no-padding m-b-xs-20">
                        <div class="ak-panel__header ak-panel__header--info ak-panel__header--small">
                            <div class="ak-panel__title">
                                {{ $t('Stookolie bestellingen') }} <b>{{ user.email }}</b>
                            </div>
                        </div>
                        <table v-if="!loading" class="ak-table ak-panel__table">
                            <thead>
                                <tr class="ak-table-row">
                                    <th class="ak-table-column">{{ $t('Bestelnummer') }}</th>
                                    <th class="ak-table-column">{{ $t('Datum') }}</th>
                                    <th class="ak-table-column">{{ $t('Bedrag') }}</th>
                                </tr>
                            </thead>
                            <tbody v-if="fuelOrders">
                                <tr v-for="fuelOrder in fuelOrders" class="ak-table-row">
                                    <td class="ak-table-column">
                                        {{ fuelOrder.orderRequest.code }}
                                    </td>
                                    <td class="ak-table-column">
                                        {{ fuelOrder.dateAdded | datetime }}
                                    </td>
                                    <td class="ak-table-column">
                                        {{ fuelOrder.orderRequest.priceTotalForDisplay }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div>
                <ak-checkbox
                    v-model="confirm"
                    :id="confirm"
                    :title="$t('Ik bevestig dat alle persoonsgegevens van @email gewist worden', {'@email': user.email})"
                />
                <ak-button
                    colorMode="secondary"
                    @click="submitForm"
                >
                    {{ $t('Persoonsgegevens wissen') }}
                </ak-button>
            </div>
        </div>
        <router-view
            name="childview"
        />
        <ak-loader size="large" :loading="loading" />
    </div>
</template>

<script>
export default {
    name: 'GDPRDelete',
    data() {
        return {
            user: null,
            orders: null,
            orderRequests: null,
            fuelOrders: null,
            confirm: false,
            loading: false,
        }
    },
    methods: {
        async initialize() {
            this.loading = true;
            const result = await this.$get('/get-user/' + this.$route.params.hashId);
            if (result.success) {
                this.user = result.data.user;
                this.orders = result.data.orders;
                this.orderRequests = result.data.orderRequests;
                this.fuelOrders = result.data.fuelOrders;
            }

            this.loading = false;
        },
        backToGrid() {
            this.$router.push({name: 'grid', params:{bundle: 'user', gridDefinition: 'grid'}});
        },
        async submitForm() {
            if ( ! this.confirm) {
                return;
            }

            this.loading = true;
            const result = await this.$get('/gdpr-delete/' + this.$route.params.hashId);
            if (result.success) {
                this.backToGrid();
                return;
            }

            this.loading = false;
        }
    },
    created() {
        this.initialize();
    }
}
</script>
